type CaptchaActionTask = {
  status: string;
  has_captcha?: boolean;
  blocked_url?: string | null;
  extension_promoted_reason?: string | null;
  parsing_success_rate?: number;
};

/** Show the list-view CAPTCHA action only for a real challenge, not missing cookies. */
export function taskNeedsCaptchaAction(task: CaptchaActionTask): boolean {
  if (task.status !== 'completed' && task.status !== 'failed') {
    return false;
  }
  // Listings were extracted — this was not a CAPTCHA wall.
  if ((task.parsing_success_rate ?? 0) > 0) {
    return false;
  }
  return (
    task.extension_promoted_reason === 'captcha' ||
    Boolean(task.has_captcha) ||
    Boolean(task.blocked_url)
  );
}
